export default "__VITE_ASSET__BIcnmF80__"